import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { TaskService } from "../../task.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { GroupsService } from "../../../../auth/service/group.service";
import { RoleService } from "../../../../auth/service/role.service";
import { FlatpickrOptions } from "ng2-flatpickr";
import Italian from "flatpickr/dist/l10n/it";
import moment from "moment";

@Component({
  selector: "app-modal-view-task",
  templateUrl: "./view-task.component.html",
  styleUrls: ["./view-task.component.scss"],
})
export class ViewTaskComponent implements OnInit {
  @Input() id: number;

  @Output() callbackFn: EventEmitter<any> = new EventEmitter();

  @ViewChild("modalViewTask") modalViewTask: ElementRef;

  public task: any = null;
  public statusChanging: boolean = false;
  public commentText: string = "";
  public canEdit: boolean = false;
  public myHash: string = "";
  public editMode: boolean = false;
  public endDate_add: FlatpickrOptions;
  public isUploadingFile: boolean = false;
  public employee_limit: number = 3;
  public employees_list: any = [];
  public assignTo: string = "";
  public list_assignTo: any = [
    {
      value: "employee",
      label: "TITLES.USERS_TYPES.employee",
    },
  ];
  public assignedUser: any = null;
  public assignedGroup: any = null;
  public assignedRole: any = null;
  public end_date: any = null;

  constructor(
    public _taskService: TaskService,
    private _modalService: NgbModal,
    public _utilsService: UtilsService,
    private _httpClient: HttpClient,
    private _authService: AuthenticationService,
    public _groupService: GroupsService,
    private _userService: UserService,
    public _roleService: RoleService,
  ) {
    this.endDate_add = {
      altFormat: "d/m/Y",
      minDate: "today",
      locale: Italian.it,
      altInput: true,
      utc: false,
      disableMobile: true,
    };
    this._utilsService.disableAutoHideLoading();
  }

  async ngOnInit() {
    this._utilsService.showLoading();
    this.employees_list = this._userService.allUserList;
    await this._groupService.getList();
    if (this._authService.hasCapability("assign_task_to_role")) {
      this.list_assignTo.push({ value: "role", label: "ROLE" });
    }

    if (this._authService.hasCapability("assign_task_to_group")) {
      this.list_assignTo.push({ value: "group", label: "GROUP" });
    }

    // se ho il diritto posso assegnare a più di tre dipendenti
    if (this._authService.hasCapability("assign_task_to_more_employee")) {
      this.employee_limit = 9999999;
    }
    await this.loadTask();
  }

  async loadTask(openModal: boolean = true) {
    /**
     STATUS: 0 = DA FARE
     STATUS: 1 = IN LAVORAZIONE
     STATUS: 2 = COMPLETATO
     **/
    await this._taskService.get(this.id).then((result: any) => {
      this.task = result;
      this.myHash = this._authService.getCurrentUser().hash;
      this.canEdit = this.myHash === this.task.creator.hash;

      if (this.task.group) {
        this.assignTo = "group";
        this.assignedGroup = this.task.group;
      } else if (this.task.role) {
        this.assignTo = "role";
        this.assignedRole = this.task.role;
      } else {
        this.assignTo = "employee";
      }

      this.assignedUser = this.task.users.map((user: any) => user.hash);

      if (this.task.end_date) {
        this.end_date = this.task.end_date;
        this.endDate_add = {
          altFormat: "d/m/Y",
          minDate: "today",
          locale: Italian.it,
          altInput: true,
          utc: false,
          disableMobile: true,
          defaultDate: this.end_date,
        };
      }

      if (openModal) {
        this._utilsService.hideLoading();
        this._modalService.open(this.modalViewTask, {
          centered: true,
          size: "xl",
          keyboard: false,
          beforeDismiss: () => {
            this.task = null;
            this.statusChanging = false;
            this.commentText = "";
            this.callbackFn.emit();
            return true;
          },
        });
      }
    });
  }

  changeAssignTo(value: string) {
    if (value === this.assignTo) {
      return false;
    }
    this.assignedUser = null;
    this.assignedGroup = null;
    this.assignedRole = null;
    this.assignTo = value;
  }

  assignToMySelf() {
    if (!this.assignedUser) {
      //Se il valore è null quindi quello inizializziamo l'array con l'hash
      this.assignedUser = [this.myHash];
    } else {
      if (!this.assignedUser.includes(this.myHash)) {
        //In questo caso è un array e prima controlliamo che già non ci sia l'hash dell'utente
        this.assignedUser = [...this.assignedUser, this.myHash];
      }
    }
  }

  closeModal() {
    this._modalService.dismissAll("Cross click");
  }

  async showAttach(url: string) {
    await this._utilsService.getFile(url);
  }

  //Setta lo stato a da fare
  async setToDoStatus() {
    try {
      this._utilsService.showLoading();
      this.statusChanging = true;
      await this._taskService.setToDo(this.task.id);
      await this._taskService.getMine();
      await this.loadTask(false);
      this.task.status = 0;
      this.statusChanging = false;
      this._utilsService.hideLoading();
      await this._utilsService.showSWALSuccess({ text: "SUCCESS_TASK_SET_AS_TODO" });
    } catch (e: any) {
      this._utilsService.hideLoading();
      await this._utilsService.showSWALError({ text: "ERROR_TASK_SET_STATUS" });
    }
  }

  //Setta lo stato a in progress
  async setTaken() {
    try {
      this._utilsService.showLoading();
      this.statusChanging = true;
      await this._taskService.setTaken(this.task.id);
      await this._taskService.getMine();
      await this.loadTask(false);
      this.task.status = 1;
      this.statusChanging = false;
      this._utilsService.hideLoading();
      await this._utilsService.showSWALSuccess({ text: "SUCCESS_TASK_SET_AS_TAKEN" });
    } catch (e: any) {
      this._utilsService.hideLoading();
      await this._utilsService.showSWALError({ text: "ERROR_TASK_SET_STATUS" });
    }
  }

  //Setta lo stato completato
  async setCompleted() {
    try {
      this._utilsService.showLoading();
      this.statusChanging = true;
      await this._taskService.setCompleted(this.task.id);
      await this._taskService.getMine();
      await this.loadTask(false);
      this.task.status = 2;
      this.statusChanging = false;
      this._utilsService.hideLoading();
      await this._utilsService.showSWALSuccess({ text: "SUCCESS_TASK_SET_AS_COMPLETED" });
    } catch (e: any) {
      this._utilsService.hideLoading();
      await this._utilsService.showSWALError({ text: "ERROR_TASK_SET_STATUS" });
    }
  }

  async removeFileFromList(attachID: number) {
    let result = await this._utilsService.showSWALDeleteConfirmation({ text: "ALERT.CONFIRM_DELETE_ATTAHCMENT_TASK" });
    if (result.value) {
      try {
        await this._taskService
          .removeAttachments(attachID);
        await this._utilsService.showPopupItemDeleted();
        this.task.attachments = this.task.attachments.filter((att: any) => att.id !== attachID);

      } catch (e) {
        return await this._utilsService.showSWALError({ text: "ERROR_TASK_ATTACHMENT_REMOVE" });
      }

    } else if (result.isDismissed) {
      await this._utilsService.showSWALError({
        title: "ABORTED_TITLE",
        text: "ABORTED_TEXT",
      });
    }
  }

  async sendComment() {
    if (this.commentText.length < 0) {
      return this._utilsService.showSWALError({ text: "MISSING_COMMENT_TEXT" });
    }
    this._utilsService.showLoading();
    try {
      await this._taskService.sendComment({ comment: this.commentText, task_id: this.task.id });
      await this._taskService.getMine();
      await this.loadTask(false);
      this.commentText = "";
      this._utilsService.hideLoading();
      await this._utilsService.showSWALSuccess({ text: "SUCCESS_TASK_COMMENT_ADDED" });
    } catch (e) {
      this._utilsService.hideLoading();
      await this._utilsService.showSWALError({ text: "ERROR_TASK_COMMENT_ADDED" });
    }
  }

  async addFileToList(files: FileList) {
    this.isUploadingFile = true;
    let uploaded: number = 0;
    let errors: number = 0;
    for (let i = 0; i < files.length; i++) {
      const file: File = files[i];
      const formData: FormData = new FormData();
      formData.append("file", file);

      const req: any = new HttpRequest("POST", `/task/attachment/${this.task.id}`, formData);

      const upload: any = await this._httpClient
        .request(req)
        .toPromise()
        .then(() => true)
        .catch(() => false);
      if (upload) {
        uploaded++;
      } else {
        errors++;
      }
    }

    const updateInterval: any = setInterval(async () => {
      if (uploaded + errors === files.length) {
        if (errors > 0) {
          await this._utilsService.showSWALSuccess({ text: "SOME_ATTACHMENT_UPLOAD_RETURN_ERROR" });
        }
        clearInterval(updateInterval);
        await this._taskService.get(this.id).then((result: any) => {
          this.task = result;
          this.isUploadingFile = false;
        });
      }
    }, 1000);
  }

  async delete() {
    let result = await this._utilsService.showSWALDeleteConfirmation({ text: "ALERT.CONFIRM_DELETE_TASK" });
    if (result.value) {
      this._utilsService.showLoading();
      try {
        await this._taskService.remove(this.task.id);
        this._utilsService.hideLoading();
        this.closeModal();
        await this._utilsService.showSWALSuccess({ text: "SUCCESS_DELETE_TASK" });
      } catch (e) {
        this._utilsService.hideLoading();
        await this._utilsService.showSWALError({ text: "ERROR_TASK_REMOVE" });
      }

    } else if (result.isDismissed) {
      await this._utilsService.showSWALError({
        title: "ABORTED_TITLE",
        text: "ABORTED_TEXT",
      });
    }
  }

  async deleteComment(id: number) {
    return this._utilsService.showSWALDeleteConfirmation({ text: "ALERT.CONFIRM_DELETE_TASK_COMMENT" }).then(async (result: any) => {
      if (result.value) {
        this._utilsService.showLoading();
        await this._taskService
          .removeComment(id)
          .then(async () => {
            this.task.comments = this.task.comments.filter((comment: any) => comment.id !== id);
            await this.loadTask(false);
            this._utilsService.hideLoading();
            await this._utilsService.showSWALSuccess({ text: "SUCCESS_DELETE_TASK_COMMENT" });
          })
          .catch(() => {
            this.task.comments = this.task.comments.filter((comment: any) => comment.id !== id);
            this._utilsService.hideLoading();
            this._utilsService.showSWALError({ text: "ERROR_TASK_COMMENT_REMOVE" });
          });
      } else if (result.isDismissed) {
        await this._utilsService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async edit() {
    if (this.end_date === null) {
      await this._utilsService.showSWALError({ text: "ERROR_ADD_TASK_MISSING_END_DATE" });
      return false;
    }
    if ((!this.assignedUser || this.assignedUser.length < 1) && (!this.assignedGroup || this.assignedGroup.length < 1) && (!this.assignedRole || this.assignedRole.length < 1)) {
      await this._utilsService.showSWALError({ text: "ERROR_ADD_TASK_MISSING_USER" });
      return false;
    }
    if (Array.isArray(this.end_date)) {
      this.end_date = moment(this.end_date[0]).format("YYYY-MM-DD");
    }
    this._utilsService.showLoading();
    return this._taskService
      .update(this.task.id, {
        title: this.task.title,
        description: this.task.description,
        priority: this.task.priority,
        users: this.assignedUser,
        group: this.assignedGroup,
        role: this.assignedRole,
        end_date: this.end_date,
      })
      .then(async () => {
        this.editMode = false;
        await this._taskService.getMine();
        await this.loadTask(false);
        await this._utilsService.showSWALSuccess({ text: "SUCCESS_UPDATING_TASK" });
      })
      .catch(async (err: any) => {
        console.error(err);
        await this._utilsService.showSWALError({ text: "ERROR_UPDATING_TASK" });
      });
  }
}
